module.exports = __webpack_public_path__ + "img/conversion.ac649edf.svg";